import {
  AccordionDetails,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  Typography
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { setConfirmExitValue } from 'src/store/confirmExitValue';

const AfterSiteQualificationVisit: React.FunctionComponent<any> = ({
  AfterSiteVisitUpdate,
  sqChecklistPILFormData,
  setSqChecklistPILFormData,
  selectedSite,
  setIsNavigateToPannel,
  checkedInStartDate
}) => {
  const { afterTheSiteQualificationVisit } = useFieldTranslation();
  const dispatch = useDispatch();
  const [isSaveBtnEnable, setIsSaveBtnEnable] = React.useState(false);

  const handleCheckBox = (e: any) => {
    const data = e.target.checked ? true : false;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: data });
    setConfirmExitValue(dispatch, true);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };

  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_sq_checklist_pil');
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checkbox-block">
        <Grid spacing={3} container className="date-block">
          <Grid item md={10}>
            {afterTheSiteQualificationVisit.header1}
          </Grid>
          <Grid item md={10}>
            <b>{afterTheSiteQualificationVisit.header2}:</b>
          </Grid>
          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label1}</Typography>}
                  value={sqChecklistPILFormData.sq_after_icf}
                  name="sq_after_icf"
                  checked={sqChecklistPILFormData.sq_after_icf ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label2}</Typography>}
                  value={sqChecklistPILFormData.sq_after_irb_sub}
                  name="sq_after_irb_sub"
                  checked={sqChecklistPILFormData.sq_after_irb_sub ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label3}</Typography>}
                  value={sqChecklistPILFormData.sq_after_budget}
                  name="sq_after_budget"
                  checked={sqChecklistPILFormData.sq_after_budget ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label4}</Typography>}
                  value={sqChecklistPILFormData.sq_after_cta}
                  name="sq_after_cta"
                  checked={sqChecklistPILFormData.sq_after_cta ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label5}</Typography>}
                  value={sqChecklistPILFormData.sq_after_document_track}
                  name="sq_after_document_track"
                  checked={sqChecklistPILFormData.sq_after_document_track ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{afterTheSiteQualificationVisit.label6}</Typography>}
                  value={sqChecklistPILFormData.sq_after_initiation_meeting}
                  name="sq_after_initiation_meeting"
                  checked={sqChecklistPILFormData.sq_after_initiation_meeting ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                {isDisable ? (
                  <Button
                    disabled={!isSaveBtnEnable || !checkedInStartDate}
                    onClick={() => {
                      AfterSiteVisitUpdate(sqChecklistPILFormData);
                      setIsSaveBtnEnable(false);
                      setIsNavigateToPannel(true);
                    }}
                    variant="text"
                  >
                    SAVE
                  </Button>
                ) : (
                  ''
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default AfterSiteQualificationVisit;
